'use client'
import { useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import TextField from '@mui/material/TextField'
import { useRouter } from 'next/navigation'

const Index = () => {
    const router = useRouter()
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
    const [searchString, setSearchString] = useState('')

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'search-popover' : undefined

    return (
        <>
            <IconButton
                size='small'
                color='inherit'
                onClick={handleClick}
                aria-describedby={id}
                aria-label="Search"
            >
                <SearchIcon />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <TextField
                    value={searchString}
                    fullWidth
                    placeholder='Search...'
                    onChange={(e) => setSearchString(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            router.push(`/search?q=${searchString}`)
                            handleClose()
                        }
                    }}
                />
            </Popover>
        </>
    )
}

export default Index


